var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ribbon position-relative",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"ribbon-wrapper"},[_c('div',{staticClass:"ribbon-front overflow-hidden"},[_c('div',{staticClass:"glow"},[_vm._v(" ")]),_vm._v(" "+_vm._s(_vm.$t('product.offer'))+" ")]),_c('div',{staticClass:"ribbon-edge-topleft"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }